export default {
    routerName: '图片详情',
    pic: {
        name: '图片名',
        thumb: '缩略图',
        image: '图片',
        status: '状态',
        open: '启用',
        close: '停用',
        description: '描述',
        sortOrder: '排序',
        createBy: '创建者',
        createTime: '创建时间',
        updateBy: '更新者',
        updateTime: '更新时间',
        type: '类型',
    },
};
